import { render, staticRenderFns } from "./GoldRecord.vue?vue&type=template&id=0649819b&scoped=true&"
import script from "./GoldRecord.vue?vue&type=script&lang=js&"
export * from "./GoldRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649819b",
  null
  
)

export default component.exports